// src/utils/featureFlags.js
import config from 'config';

// Applies overrides to feature flags based on query params

function getFeatureFlagOverrides() {
  const params = new URLSearchParams(window.location.search);
  const overrides = {};

  // Iterate through all query params
  for (const [key, value] of params.entries()) {
    if (key.toLowerCase().startsWith('ff_')) {
      // Convert ff_japan_enrollment to FEATURE_FLAG_JAPAN_ENROLLMENT
      const flagKey = `FEATURE_FLAG_${key.substring(3).toUpperCase()}`;

      // Only override if the flag exists in config
      if (flagKey in config) {
        overrides[flagKey] = value.toLowerCase() === 'true';
      }
    }
  }

  return overrides;
}

export function initFeatureFlagOverrides() {
  const overrides = getFeatureFlagOverrides();

  Object.entries(overrides).forEach(([key, value]) => {
    config[key] = value;
  });
}
